import React, { useState, useRef, useLayoutEffect, useCallback } from 'react';
import classNames from 'classnames';
import { Popover } from 'react-tiny-popover';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ palette, spacing, componentSizing, zIndex }) => ({
    tooltip: {
        maxWidth: componentSizing.tooltipWidth,
        backgroundColor: palette.background.default,
        padding: spacing(),
        border: `1px solid ${palette.secondary.main}`,
        borderRadius: spacing(0.5),
    },
    container: {
        zIndex: zIndex.tooltip,
    },
}));
function ToolTip({ children, content, className, spanClassName, align, position, }) {
    const classes = useStyles();
    // unsafe because it could be called when the component is unmounted creating a memory leak
    const [hover, unsafeSetHover] = useState(false);
    // ensures the set state is only called if the component is mounted
    const mountedRef = useRef(false);
    useLayoutEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    const setHover = useCallback((hoverState) => {
        if (mountedRef.current) {
            unsafeSetHover(hoverState);
        }
    }, []);
    return (React.createElement(Popover, { isOpen: hover, containerClassName: classes.container, content: React.createElement("div", { className: classNames(classes.tooltip, className) }, content), align: align, positions: position },
        React.createElement("span", { className: spanClassName, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) }, children)));
}
export default ToolTip;
//# sourceMappingURL=ToolTip.js.map